import { render, staticRenderFns } from "./DataFrom.vue?vue&type=template&id=bbe0df50"
import script from "./DataFrom.vue?vue&type=script&lang=js"
export * from "./DataFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports